module.exports = __webpack_public_path__ + "static/bg-75264d9aeb27552c557ac4e7dcfe97a8.png";